import Guard from '@/services/middleware'

const ActionsHome = () => import('@/views/dash/settings/actions/HomeActions.vue')
const ListCategories = () => import('@/views/dash/settings/actions/ListCategories.vue')
const ActionsLists = () => import('@/views/dash/settings/actions/ListActions.vue')
export default [
    {
        path: '/acoes',
        name: 'actions.home',
        component: ActionsHome,
        meta: { title: 'Ações', permission: 2, name: 'message' },
        children: [
            {
                path: '',
                name: 'actions.message',
                component: ListCategories,
                meta: { title: 'Mensagens automaticas', permission: 2, name:'message', module: 'messages_automatic'},
                beforeEnter: [Guard.redirectIfNotAuthenticated, Guard.checkModuleAccess],
            },
            {
                path: 'mensagens',
                name: 'actions.messages',
                component: ListCategories,
                meta: { title: 'Mensagens automaticas', permission: 2, name:'message',  module: 'messages_automatic'},
                beforeEnter: [Guard.redirectIfNotAuthenticated, Guard.checkModuleAccess],
            },
            {
                path: 'mensagens/:id',
                name: 'actions.message.item',
                component: ActionsLists,
                meta: { title: 'Messagens automaticas', permission: 2, name:'message' ,  module: 'messages_automatic'},
                beforeEnter: [Guard.redirectIfNotAuthenticated, Guard.checkModuleAccess],
            },
            {
                path: 'notificacoes',
                name: 'actions.notification',
                component: ListCategories,
                meta: { title: 'Notificações automaticas',  permission: 2, name:'notification' },
            },
            {
                path: 'notification/:id',
                name: 'actions.notification.item',
                component: ActionsLists,
                meta: { title: 'Notificações automaticas', permission: 2, name:'notification' },
            },
        ],
    },

]